export default __webpack_public_path__ + "static/media/img-influencer-02.81713400.png";